import { axiosInstance } from '../axios-instance';
import { IPopupResponse } from './types';

export const getActivePopups = async (): Promise<IPopupResponse> => {
  return axiosInstance.get('/popups/active');
};

export const getMockPopups = (): Promise<IPopupResponse> => {
  return Promise.resolve({
    data: [
      {
        id: 'school-starts-video',
        title: 'Okul Başlıyor',
        videoUrl: 'https://player.vimeo.com/video/1112907460',
        startDate: '2025-09-08',
        endDate: '2025-09-12',
        type: 'celebration',
        target: {},
      },
      {
        id: 'purchase-reminder',
        title: 'Satın Alma Hatırlatma',
        videoUrl: 'https://player.vimeo.com/video/1113914130',
        startDate: '2025-09-12',
        endDate: '2025-09-23',
        type: 'info',
        target: {
          organizations: ['Nesibe Aydın Okulları'],
        },
      },
      {
        id: 'new-year-video',
        title: '1 Ocak Yeniyıl Videosu',
        content: 'Yeni yıl kutlu olsun! 🎉',
        videoUrl: 'https://player.vimeo.com/video/1112902349',
        startDate: '2025-12-31',
        endDate: '2026-01-01',
        type: 'celebration',
        target: {
          organizations: [
            'Başkent Okulları',
            'Oya Akın Eğitim Kurumları',
            'Tarsus Amerikan Koleji',
            'Bilinç Koleji',
            'Türk İnteqrasiyon Olimpiad (TIO)',
            'Safa Okulları',
            'T7 Teknoloji Anaokulu',
            'Kutlubey Eğitim Kurumları',
            'Serçe Akademi',
            'Mavi Dünya Okulları',
            'Doğa Koleji',
            'E12',
            'Nesibe Aydın Okulları',
            'Aydın Kurs',
            'FSIO Olympiad',
            'E12 Okulları',
          ],
        },
      },
      {
        id: 'science-fiction-day',
        title: '2 Ocak Bilim Kurgu Günü',
        content: 'Bilim kurgu dünyasına hoş geldiniz! 🚀',
        videoUrl: 'https://player.vimeo.com/video/1112902496',
        startDate: '2026-01-02',
        endDate: '2026-01-02',
        type: 'celebration',
        target: {},
      },
      {
        id: 'world-cats-day',
        title: 'Dünya Kediler Günü',
        content: 'Sevimli dostlarımızı unutmayalım! 🐱',
        videoUrl: 'https://player.vimeo.com/video/1112902176',
        startDate: '2026-02-17',
        endDate: '2026-02-17',
        type: 'celebration',
        target: {},
      },
      {
        id: 'science-tech-week',
        title: 'Bilim ve Teknoloji Haftası',
        content: 'Bilim ve teknolojinin gücüyle geleceği şekillendiriyoruz! 🔬',
        videoUrl: 'https://player.vimeo.com/video/1112902538',
        startDate: '2026-03-08',
        endDate: '2026-03-14',
        type: 'info',
        target: {},
      },
      {
        id: 'medicine-day',
        title: 'Tıp Bayramı',
        content: 'Sağlık kahramanlarını onurlandırıyoruz! 🏥',
        videoUrl: 'https://player.vimeo.com/video/1113914173',
        startDate: '2026-03-14',
        endDate: '2026-03-14',
        type: 'celebration',
        target: {},
      },
      {
        id: 'world-theatre-day',
        title: 'Dünya Tiyatrolar Günü',
        content: 'Sanatın büyüsüne kapılalım! 🎭',
        videoUrl: 'https://player.vimeo.com/video/1112901988',
        startDate: '2026-03-27',
        endDate: '2026-03-27',
        type: 'celebration',
        target: {},
      },
      {
        id: 'world-water-day',
        title: 'Dünya Su Günü',
        content: 'Su hayattır, koruyalım! 💧',
        videoUrl: 'https://player.vimeo.com/video/1112901969',
        startDate: '2026-03-22',
        endDate: '2026-03-22',
        type: 'info',
        target: {},
      },
      {
        id: 'world-forest-week',
        title: 'Dünya Orman Haftası',
        content: 'Yeşil dünyanın koruyucuları olalım! 🌲',
        videoUrl: 'https://player.vimeo.com/video/1112902419',
        startDate: '2026-03-21',
        endDate: '2026-03-26',
        type: 'info',
        target: {},
      },
      {
        id: 'library-week',
        title: 'Kütüphane Haftası',
        content: 'Kitaplar bilginin hazinesidir! 📚',
        videoUrl: 'https://player.vimeo.com/video/1112902200',
        startDate: '2026-03-30',
        endDate: '2026-04-05',
        type: 'info',
        target: {},
      },
      {
        id: 'world-joke-day',
        title: 'Dünya Şaka Günü',
        content: 'Gülmeyi unutmayalım! 😄',
        videoUrl: 'https://player.vimeo.com/video/1112902571',
        startDate: '2026-04-01',
        endDate: '2026-04-01',
        type: 'celebration',
        target: {},
      },
      {
        id: 'street-animals-day',
        title: 'Sokak Hayvanları Günü',
        content: 'Sokak dostlarımızı unutmayalım! 🐕',
        videoUrl: 'https://player.vimeo.com/video/1112902224',
        startDate: '2026-04-04',
        endDate: '2026-04-04',
        type: 'info',
        target: {},
      },
      {
        id: 'national-sovereignty-children-day',
        title: 'Ulusal Egemenlik ve Çocuk Bayramı',
        content: 'Geleceğimizin teminatı çocuklarımız! 🇹🇷',
        videoUrl: 'https://player.vimeo.com/video/1112902384',
        startDate: '2026-04-23',
        endDate: '2026-04-23',
        type: 'celebration',
        target: {},
      },
      {
        id: 'traffic-first-aid-week',
        title: 'Trafik ve İlkyardım Haftası',
        content: 'Güvenli yolculuklar dileriz! 🚦',
        videoUrl: 'https://player.vimeo.com/video/1112902312',
        startDate: '2026-05-01',
        endDate: '2026-05-07',
        type: 'info',
        target: {},
      },
      {
        id: 'disabled-week',
        title: 'Engelliler Haftası',
        content: 'Herkes için eşit fırsatlar! ♿',
        videoUrl: 'https://player.vimeo.com/video/1112902021',
        startDate: '2026-05-10',
        endDate: '2026-05-16',
        type: 'info',
        target: {},
      },
      {
        id: 'mothers-day',
        title: 'Anneler Günü',
        content: 'En değerli varlığımız annelerimiz! ❤️',
        videoUrl: 'https://player.vimeo.com/video/1112902462',
        startDate: '2026-05-10',
        endDate: '2026-05-10',
        type: 'celebration',
        target: {},
      },
      {
        id: 'nurses-week',
        title: 'Hemşireler Haftası',
        content: 'Sağlık meleklerimizi onurlandırıyoruz! 👩‍⚕️',
        videoUrl: 'https://player.vimeo.com/video/1112902133',
        startDate: '2026-05-12',
        endDate: '2026-05-12',
        type: 'celebration',
        target: {},
      },
      {
        id: 'ataturk-youth-sports-day',
        title: 'Atatürkü Anma Gençlik ve Spor Bayramı',
        content: 'Gençliğe güvenen lider Atatürkü anıyoruz! 🇹🇷',
        videoUrl: 'https://player.vimeo.com/video/1113914226',
        startDate: '2026-05-19',
        endDate: '2026-05-19',
        type: 'celebration',
        target: {},
      },
      {
        id: 'cancer-fight-week',
        title: 'Kanserle Savaş Haftası',
        content: 'Umut ve mücadele ruhuyla! 💪',
        videoUrl: 'https://player.vimeo.com/video/1112902161',
        startDate: '2026-04-01',
        endDate: '2026-04-07',
        type: 'info',
        target: {},
      },
      {
        id: 'entrepreneurship-week',
        title: 'Girişimcilik Haftası',
        content: 'Girişimcilik ruhunu yaşayalım! 💼',
        videoUrl: 'https://player.vimeo.com/video/1112902094',
        startDate: '2026-03-01',
        endDate: '2026-03-07',
        type: 'info',
        target: {},
      },
      {
        id: 'world-hygiene-day',
        title: 'Dünya Hijyen Günü',
        content: 'Temizlik sağlığın temelidir! 🧼',
        videoUrl: 'https://player.vimeo.com/video/1112902264',
        startDate: '2026-01-16',
        endDate: '2026-01-16',
        type: 'info',
        target: {},
      },
      {
        id: 'deneme-sinavi-5-sinif',
        title: 'Türkiye Geneli 5. Sınıf Deneme Sınavı',
        content: '<img src="/popup/5.jpg" alt="5. Sınıf Deneme Sınavı" />',
        startDate: '2025-12-11',
        endDate: '2025-12-13',
        type: 'info',
        target: {
          organizations: [
            'Nesibe Aydın Okulları',
            'Aydın Kurs',
            'Serçe Akademi',
            'E12 Okulları',
          ],
          grades: ['5'],
        },
      },
      {
        id: 'deneme-sinavi-6-sinif',
        title: 'Türkiye Geneli 6. Sınıf Deneme Sınavı',
        content: '<img src="/popup/6.jpg" alt="6. Sınıf Deneme Sınavı" />',
        startDate: '2025-12-11',
        endDate: '2025-12-13',
        type: 'info',
        target: {
          organizations: [
            'Nesibe Aydın Okulları',
            'Aydın Kurs',
            'Serçe Akademi',
            'E12 Okulları',
          ],
          grades: ['6'],
        },
      },
      {
        id: 'deneme-sinavi-7-sinif',
        title: 'Türkiye Geneli 7. Sınıf Deneme Sınavı',
        content: '<img src="/popup/7.jpg" alt="7. Sınıf Deneme Sınavı" />',
        startDate: '2025-12-11',
        endDate: '2025-12-14',
        type: 'info',
        target: {
          organizations: [
            'Nesibe Aydın Okulları',
            'Aydın Kurs',
            'Serçe Akademi',
            'E12 Okulları',
          ],
          grades: ['7'],
        },
      },
      {
        id: 'deneme-sinavi-9-sinif',
        title: 'Türkiye Geneli 9. Sınıf Deneme Sınavı',
        content: '<img src="/popup/9.jpg" alt="9. Sınıf Deneme Sınavı" />',
        startDate: '2025-12-11',
        endDate: '2025-12-13',
        type: 'info',
        target: {
          organizations: [
            'Nesibe Aydın Okulları',
            'Aydın Kurs',
            'Serçe Akademi',
            'E12 Okulları',
          ],
          grades: ['9'],
        },
      },
      {
        id: 'deneme-sinavi-10-sinif',
        title: 'Türkiye Geneli 10. Sınıf Deneme Sınavı',
        content: '<img src="/popup/10.jpg" alt="10. Sınıf Deneme Sınavı" />',
        startDate: '2025-12-11',
        endDate: '2025-12-13',
        type: 'info',
        target: {
          organizations: [
            'Nesibe Aydın Okulları',
            'Aydın Kurs',
            'Serçe Akademi',
            'E12 Okulları',
          ],
          grades: ['10'],
        },
      },
      {
        id: 'deneme-sinavi-11-sinif',
        title: 'Türkiye Geneli 11. Sınıf Deneme Sınavı',
        content: '<img src="/popup/11.jpg" alt="11. Sınıf Deneme Sınavı" />',
        startDate: '2025-12-11',
        endDate: '2025-12-14',
        type: 'info',
        target: {
          organizations: [
            'Nesibe Aydın Okulları',
            'Aydın Kurs',
            'Serçe Akademi',
            'E12 Okulları',
          ],
          grades: ['11'],
        },
      },
      {
        id: 'deneme-sinavi-12-sinif',
        title: 'Türkiye Geneli YKS Deneme Sınavları',
        content:
          '<img src="/popup/12-mezun.jpg" alt="12. Sınıf Deneme Sınavı" />',
        startDate: '2025-12-11',
        endDate: '2025-12-14',
        type: 'info',
        target: {
          organizations: [
            'Nesibe Aydın Okulları',
            'Aydın Kurs',
            'Serçe Akademi',
            'E12 Okulları',
          ],
          grades: ['12', 'Mezun'],
        },
      },
      {
        id: 'duyuru-baraj',
        title: 'Barajları Birlikte Aşalım!',
        content:
          '<img src="/popup/duyuru-baraj.png" alt="Duyuru: Barajları Birlikte Aşalım!" />',
        startDate: '2025-12-15',
        endDate: '2025-12-22',
        type: 'announcement',
        target: {
          organizations: [
            'Nesibe Aydın Okulları',
            'Serçe Akademi',
            'E12 Okulları',
          ],
          grades: ['5', '6', '7', '8', '9', '10', '11'],
        },
      },
    ],
    error: null,
  });
};
